/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Roadmap_HintInputs */

const en_us2_community_roadmap_hint = /** @type {(inputs: Community_Roadmap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vote for what you want first`)
};

const pt_br2_community_roadmap_hint = /** @type {(inputs: Community_Roadmap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vote no que você quer primeiro`)
};

const es_419_community_roadmap_hint = /** @type {(inputs: Community_Roadmap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vota por lo que quieres primero`)
};

const pt_pt2_community_roadmap_hint = /** @type {(inputs: Community_Roadmap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vota no que queres primeiro`)
};

const fr_fr2_community_roadmap_hint = /** @type {(inputs: Community_Roadmap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vote pour ce que tu veux en premier`)
};

const de_de2_community_roadmap_hint = /** @type {(inputs: Community_Roadmap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimm ab, was du zuerst willst`)
};

const it_it2_community_roadmap_hint = /** @type {(inputs: Community_Roadmap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vota cosa vuoi per primo`)
};

/**
* | output |
* | --- |
* | "Vote for what you want first" |
*
* @param {Community_Roadmap_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_roadmap_hint = /** @type {((inputs?: Community_Roadmap_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Roadmap_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_roadmap_hint(inputs)
	if (locale === "es-419") return es_419_community_roadmap_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_community_roadmap_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_community_roadmap_hint(inputs)
	if (locale === "de-DE") return de_de2_community_roadmap_hint(inputs)
	if (locale === "it-IT") return it_it2_community_roadmap_hint(inputs)
	return en_us2_community_roadmap_hint(inputs)
});
export { community_roadmap_hint as "community.roadmap_hint" }